
import { Options } from "vue-class-component";

import { Col, Row } from "vant";
import BasePage from "@/common/BasePage"; // @ is an alias to /src
import TenantVo from "@/vo/TenantVo"; // @ is an alias to /src
import StaffItem from "@/components/item/StaffItem.vue"; // @ is an alias to /src
import MyTabbar from "@/components/Tabbar.vue";
import WxUtil from "@/util/WxUtil";
import AppUtil from "@/util/AppUtil";

@Options({
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    Tabbar: MyTabbar,
    StaffItem,
  },
})
export default class Index extends BasePage {
  tenantInfo: TenantVo = TenantVo.getInstance();
  /**员工数组*/
  private staffList: any[] = [];
  /**门店展板信息*/
  private _imgList = false;
  created(){
    // super.created()
    setTimeout(() => {
       document.title = this.tenantInfo.name;
    }, 2000);
  }
  mounted(): void {
    // WxUtil.get_wx().then((wx) => {
    //   console.log("获取位置");

    //   wx.getLocation({
    //     type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
    //     success: function (res: any) {
    //       // var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
    //       // var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
    //       // var speed = res.speed; // 速度，以米/每秒计
    //       // var accuracy = res.accuracy; // 位置精度
    //       console.log("获取到坐标1", res);
    //     },
    //     fail: function (res: any) {
    //       console.log("获取位置失败", res);
    //     },
    //   });
    // });

    this.req_staffList();
  }
  qh_click(){
     this.$router.push("/shopList");
  }
  /**拨打电话 */
  tel_click() {
    window.location.href = "tel:" + this.tenantInfo.leadPhone;
  }
  /**获取员工信息*/
  private req_staffList(): void {
    // console.log("首页门店信息");
    AppUtil.request(
      {
        url: "/zhTenant/tenant/getStaffList",
        method: "post",
        data: {
          page: 1,
          limit: 3,
        },
      },
      (res: any) => {
        // console.log("获取员工信息",res);
        if (res.data) {
          res.data.map((val: any) => {
            val.thumb = this.get_thumb(val.photoWall, 200, 220);
            val.serviceNum = val.serviceNum || 0; //如果后台没有返回服务数量，就默认零
          });
          this.staffList = res.data;
        }
        // console.log("this.staffList", this.staffList);
        this.req_imgList();
      }
    );
  }
  /* 请求门店展板信息*/
  private req_imgList(): void {
    AppUtil.request(
      {
        url: "/zhTenant/tenant/getDisplayBoardImgList",
        method: "post",
        data: {
          page: 1,
          limit: 10,
        },
      },
      (res: any) => {
        console.log("门店展板信息", res);

        if (res.data) {
          res.data.map((val: any) => {
            val.thumb = this.get_thumb(val.imgUrl, 300, 200);
          });
          this._imgList = res.data;
        }
        // this.req_imgList();
      }
    );
  }
   map_click() {
    
    let tenantInfo = this.tenantInfo;
    // console.log(tenantInfo.name,parseFloat( tenantInfo.latitude.toString()));
    
    WxUtil.get_wx().then((wx) => {
      wx.openLocation({
        latitude:parseFloat( tenantInfo.latitude.toString()), // 纬度，浮点数，范围为90 ~ -90
        longitude:parseFloat(tenantInfo.longitude.toString()) , // 经度，浮点数，范围为180 ~ -180。
        name: tenantInfo.name, // 位置名
        address: tenantInfo.addressDetail, // 地址详情说明
        scale: 14, // 地图缩放级别,整型值,范围从1~28。默认为最大
        infoUrl: "", // 在查看位置界面底部显示的超链接,可点击跳转
      });
    });
  }
  ///跳转员工列表页面
  private all_staff_click() {
    this.$router.push("/staff/list");
  }
  ///跳转展板列表页面
  private all_img_click() {
    this.$router.push("/imgList");
  }
  /**没有数据时，返回false*/
  get staffArr() {
    if (!this.staffList.length) {
      return false;
    }
    return this.staffList;
  }
  get imgArr() {
    return this._imgList;
  }
}
